import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=012ee1f9&scoped=true&"
import script from "./Split.vue?vue&type=script&lang=js&"
export * from "./Split.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ee1f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012ee1f9')) {
      api.createRecord('012ee1f9', component.options)
    } else {
      api.reload('012ee1f9', component.options)
    }
    module.hot.accept("./Split.vue?vue&type=template&id=012ee1f9&scoped=true&", function () {
      api.rerender('012ee1f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Split.vue"
export default component.exports